export const metadata = {
  title: "Sky Freight Oman",
  description: "Welcome to Sky Freight Oman.",
}

export default function TemplateBlank({ children }: Props) {
  return (
    <>
      <main className="flex-1">{children}</main>
    </>
  )
}